<template>
  <modal-structure
    :affirmative-handler="handleAffirmative"
    :btn-ok-text="this.$t('assign_domain.button')"
    :negative-handler="handleNegative"
    :show-loading="showLoading"
    :error-message="errorMessage"
    :success-message="successMessage"
  >
    <template v-slot:header>
      <div class="title has-text-centered">
        {{ $t('assign_service.title') }} <span class="domain-name">{{ domainData && domainData.domainName }}</span>
      </div>
    </template>
    <template v-slot:content>
      <div
        v-for="(service, index) in servicesList"
        :key="index"
      >
        <label
          class="checkbox"
        >
          <input
            :id="service.id"
            v-model="service.checked"
            type="checkbox"
          >
          <label v-if="service.type === 'sitepluswebsite'">
            {{ $t('assign_service.siteplus') }}
          </label>
          <label v-else-if="service.type === 'yolawebsite'">
            {{ $t('assign_service.yolawebsite') }}
          </label>
          <label v-else-if="service.type === 'flockemail'">
            {{ $t('assign_service.flockemail') }}
          </label>
          <label v-else>
            {{ service.type }}
          </label>
        </label>
      </div>
    </template>
    <template v-slot:footer />
  </modal-structure>
</template>

<script>
import { SECONDS_IN_MS } from '@/helpers'
import { mapState, mapGetters } from 'vuex'
import ModalStructure from './ModalStructure'
import assignableServicesMixin from '@/mixins/assignable-services'

export default {

  name: 'AssignServices',
  components: {
    ModalStructure
  },

  mixins: [
    assignableServicesMixin
  ],

  data () {
    return {
      servicesList: [],
      showLoading: false,
      errorMessage: '',
      successMessage: ''
    }
  },

  computed: {
    ...mapState(['services', 'account', 'displayName']),
    ...mapGetters('domainService', ['domainData'])
  },

  mounted () {
    return this.getServicesList()
  },

  methods: {

    async getServicesList () {
      var response = await this.getAssignableServices(this.account.accountId)

      if (response) {
        response.forEach(service => {
          this.servicesList.push({
            id: service.id,
            type: service.type,
            checked: false
          })
        })
      }
    },

    async handleAffirmative () {
      var serviceIds = []
      this.errorMessage = ''
      this.successMessage = ''

      if (this.servicesList && this.servicesList.length > 0) {
        this.servicesList.forEach(element => {
          if (element.checked === true) {
            serviceIds.push(element.id)
          }
        })

        // call to mutation
        if (serviceIds.length > 0) {
          this.showLoading = true
          var response = await this.assignServices(serviceIds, this.account.accountId, this.domainData.domainName)
          if (response) {
            this.successMessage = this.$t('common.info_edited_ok')
            this.errorMessage = ''
            this.showLoading = false
            this.$root.$emit('close::custom::modal')
            setTimeout(() => {
              this.$router.push({ name: 'MainSection' })
            }, SECONDS_IN_MS(2))
          } else {
            this.errorMessage = this.$t('common.try_again')
            this.successMessage = ''
            this.showLoading = false
            setTimeout(() => {
              this.errorMessage = ''
            }, SECONDS_IN_MS(2))
          }
        }
      }
    },

    handleNegative () {
    }
  }

}
</script>
<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
.domain-name {
  color: var(--primary-color);
}
</style>
